<template>
  <div class="d-flex flex-column profile-setup-phone">
    <div>
      <SecondaryText class="font-size-xs">
        <template v-if="!phoneVerify">
          {{
            $$t(
              'Please provide the phone number to protect your account. You will get the ability login via phone number.',
              'enter-phone-info'
            )
          }}
        </template>
        <template v-else>
          {{
            $$t(
              "We've sent the verification code to this phone number. Please do not tell this code to anyone.",
              'enter-code-info'
            )
          }}
        </template>
      </SecondaryText>
      <div class="mb-4"></div>
      <!--fix spacing-->
      <template v-if="!phoneVerify">
        <div class="phone-row d-flex align-items-center">
          <InputPhone
            ref="inputPhone"
            v-model="phoneNumber"
            :label="$$t('Phone')"
            input-autofocus
          />
          <FormBtn
            class="btn-primary mx-2"
            :loading="isLoadingSetPhone"
            :disabled="!phoneNumber"
            @click.native="setPhoneVerify"
          >
            {{ $$t('Add Phone', 'add') }}
          </FormBtn>
        </div>
      </template>

      <template v-else>
        <span
          v-if="selectedCountry"
          class="cursor-pointer profile-setup-phone-value"
          @click="changePhoneVerify"
        >
          <img
            :src="selectedCountry.logo"
            :alt="selectedCountry.name"
            class="h-mr-2"
          />
          +{{ phoneVerify }}
        </span>
        <div class="verify-row d-flex mt-3 mb-4">
          <InputVerify
            v-model="verifyCode"
            @onSubmit="sendCodeVerify"
            @error="sendCodeError"
          />
          <FormBtn
            v-if="phoneVerify"
            class="btn-primary mx-2"
            :disabled="!!(errors || !verifyCode)"
            :loading="isLoadingVerifyPhone"
            @click.native="sendCodeVerify"
          >
            {{ $$t('Verify Phone', 'verify') }}
          </FormBtn>
        </div>
        <div v-if="errors" class="mb-2 text-danger">
          {{ errors }}
        </div>
        <ResendCode
          class="pb-3 text-muted"
          :action="sendCode"
          :action-data="verifyData"
          :timeout-text-translate-key="$$tCreateKey('timeout-text')"
          timeout-text-default="SMS code has been sent. Re-send code in {timer} sec."
          :resend-text-translate-key="$$tCreateKey('retry-text')"
          resend-text-default="SMS code has been sent. If you didn't get sms, try to {:resend}."
        />
      </template>
      <div class="d-flex justify-content-center">
        <!-- <FormBtn
          class="text-primary mx-2"
          :disabled="isLoadingSetPhone || isLoadingVerifyPhone"
          @click.native="$emit('skip', true)"
        >
          {{ $$t('Skip Adding Phone', 'skip') }}
        </FormBtn> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { translate } from '@/mixins/translate';
import { loader } from '@/mixins/isLoadingAlt';
import SecondaryText from '@/components/atoms/SecondaryText';
import InputPhone from '@/components/form/InputPhone';
import FormBtn from '@/components/atoms/HeraFormBtn';
import InputVerify from '@/components/form/InputVerify';
import ResendCode from '@/components/text/ResendCode';

export default {
  name: 'ProfileSetupGames',
  components: {
    ResendCode,
    InputVerify,
    FormBtn,
    InputPhone,
    SecondaryText,
  },
  mixins: [
    loader('isLoadingSetPhone', 'isLoadingVerifyPhone'),
    translate('_web_profile-setup_phone'),
  ],
  data() {
    return {
      phoneNumber: '',
      phoneVerify: '',
      verifyCode: '',
      selectedCountry: null,
      errors: '',

      //helper
      isLoadingSetPhone: false,
      isLoadingVerifyPhone: false,
    };
  },
  computed: {
    verifyData() {
      return {
        phone: `+${this.phoneVerify || this.phoneNumber}`,
      };
    },
  },
  methods: {
    ...mapActions(['verifyUser', 'sendCode', 'errorNotify']),
    setPhoneVerify() {
      this.selectedCountry =
        this.$lodash.get(this, '$refs.inputPhone.selectedCountry') || null;

      this.setLoading('isLoadingSetPhone');
      this.sendCode(this.verifyData)
        .then(() => {
          this.phoneVerify = this.phoneNumber;
        })
        .catch(this.errorNotify)
        .finally(() => {
          this.unsetLoading('isLoadingSetPhone');
        });
    },
    changePhoneVerify() {
      this.phoneVerify = '';
    },
    sendCodeVerify() {
      this.setLoading('isLoadingVerifyPhone');
      return this.verifyUser({
        code: this.verifyCode,
        phone: `+${this.phoneVerify}`,
        from: 'verify-phone',
      })
        .then(() => {
          this.$emit('skip', true);
        })
        .catch(this.errorNotify)
        .finally(() => {
          this.unsetLoading('isLoadingVerifyPhone');
        });
    },
    sendCodeError(err) {
      this.errors = err;
    },
  },
};
</script>

<style lang="scss">
.profile-setup-phone {
  // width: 30rem;
  .hera-input-phone label {
    font-size: $ph-body-font-size !important;
  }
  .input-verify {
    width: 22rem;
  }
  &-value {
    opacity: 0.9;
    &:hover {
      opacity: 1;
    }
    img {
      width: 1.5rem;
      height: 1.5rem;
      object-fit: contain;
    }
  }
  .phone-row,
  .verify-row {
    gap: 1rem;
  }
  .input-group {
    &.hera-input-phone_input-group {
      border: 0;

      .input-group-prepend:first-of-type {
        @include auto-rtl(margin-right, 1rem);
        > .btn {
          border: solid 1px !important;
          border-color: var(--ph-input-borders) !important;
          background-color: var(--ph-bg) !important;
        }
      }
      > .input-group-append > .input-group-text {
        border-radius: $ph-medium-radius !important;
      }
      > .input-group-prepend > .btn,
      > .input-group-prepend + input {
        max-width: 160px;
        border: solid 1px var(--ph-input-borders) !important;
        border-radius: $ph-medium-radius !important;
        background-color: var(--ph-bg) !important;
      }
    }
  }
}
</style>
